import React, { useState } from 'react';
import { Action } from '@reduxjs/toolkit';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { Button, Menu, MenuItem } from '@mui/material';

import { hasProductionGroupManagementPermission } from '@paragon/login-tools';

import {
  showAddToProductionGroupDialog,
  showCreateProductionGroupDialog,
  showManageProductionGroupsDialog,
  showReplaceProductionComponentsDialog,
} from '../../store/actions/dialogActions';
import { ThunkActionVoid } from '../../store/actions/thunkActions';
import { ProjectActionScope } from '../../store/projectActionScope';
import { useAppDispatch, useAppSelector } from '../hooks';

interface ProductionButtonsProps {
  readonly scope: ProjectActionScope;
}

export function ProductionButtons({ scope }: ProductionButtonsProps) {
  const dispatch = useAppDispatch();
  const userHasProductionGroupManagementPermission = useAppSelector(hasProductionGroupManagementPermission);

  const [menuAnchorEl, setMenuAnchorEl] = useState<HTMLElement | null>(null);
  const menuIsOpen = !!menuAnchorEl;

  if (!userHasProductionGroupManagementPermission) return null;

  const closeAndDispatch = (action: Action | ThunkActionVoid) => () => {
    setMenuAnchorEl(null);
    dispatch(action);
  };

  return (
    <>
      <Button size="small" onClick={(event) => setMenuAnchorEl(event.currentTarget)} endIcon={<ArrowDropDownIcon />}>
        Production
      </Button>
      <Menu open={menuIsOpen} anchorEl={menuAnchorEl} onClose={() => setMenuAnchorEl(null)}>
        <MenuItem onClick={closeAndDispatch(showCreateProductionGroupDialog(scope))}>Create Production Group</MenuItem>
        <MenuItem onClick={closeAndDispatch(showAddToProductionGroupDialog(scope))}>Add to Production Group</MenuItem>
        <MenuItem onClick={closeAndDispatch(showManageProductionGroupsDialog(scope))}>
          Manage Production Groups
        </MenuItem>
        <MenuItem onClick={closeAndDispatch(showReplaceProductionComponentsDialog(scope))}>
          Replace Production Components
        </MenuItem>
      </Menu>
    </>
  );
}
